import render from './render'

export default {
  name: 'Errors',

  props: {
    // ReportTaskQueue
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      showDialog: false
    }
  },

  render
}
